import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {ViewModeService} from '../view-mode.service';
import {Subscription} from 'rxjs';
import {ProductListComponentService, ViewModes} from '@spartacus/storefront';
import {ProductSearchPage} from '@spartacus/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'dcp-results-list',
  templateUrl: './results-list.component.html',
})
export class ResultsListComponent implements OnInit, OnDestroy {

  viewMode: ViewModes;
  ViewModes = ViewModes;
  model: ProductSearchPage;
  private viewModeSubscription: Subscription;
  private modelSubscription: Subscription;

  constructor(
    private viewModeService: ViewModeService,
    private productListComponentService: ProductListComponentService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.viewModeSubscription = this.viewModeService.getViewMode$().pipe(untilDestroyed(this)).subscribe(value => {
      this.viewMode = value;
      this.changeDetectorRef.detectChanges();
    });
    this.modelSubscription = this.productListComponentService.model$.pipe(untilDestroyed(this)).subscribe(value => {
      this.model = value;
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.modelSubscription.unsubscribe();
    this.viewModeSubscription.unsubscribe();
  }
}
